<div class="office-communication-main" data-cy="office-communication">
  <div class="tdo-note-dialog-nav" style="border-top-left-radius: 6px; border-bottom-left-radius: 6px; overflow-y: auto;" data-cy="office-communication-nav">
    <div class="column-label" style="margin-top: 4px;" data-cy="office-communication-online-label">
      Online Users:
      <hr />
    </div>
    <ng-container *ngFor="let user of signalrService.connectedUsers">
      <div class="tdo-note-dialog-nav-list-item"
           [ngClass]="{'tdo-note-dialog-nav-list-item-selected': isConversationSelected(user)}"
           (click)="onConversationClick(user)"
           style="text-align: right;"
           *ngIf="!isSelfUser(user.UserID)" data-cy="office-communication-online-user-{{user.UserID}}">
        <div style="width: 100%; padding-right: 6px;" data-cy="office-communication-online-user-name">{{ user.UserName }}</div>
      </div>
    </ng-container>

    <div class="column-label" style="margin-top: 8px;" data-cy="office-communication-offline-label">
      Offline Users:
      <hr />
    </div>
    <ng-container *ngFor="let user of signalrService.disconnectedUsers">
      <div class="tdo-note-dialog-nav-list-item"
           [ngClass]="{'tdo-note-dialog-nav-list-item-selected': isConversationSelected(user)}"
           (click)="onConversationClick(user)"
           style="text-align: right; color: #cccccc;"
           *ngIf="!isSelfUser(user.UserID)" data-cy="office-communication-offline-user-{{user.UserID}}">
        <div style="width: 100%; padding-right: 6px;" data-cy="office-communication-offline-user-name">{{ user.UserName }}</div>
      </div>
    </ng-container>
  </div>
  <div class="office-communication-content" data-cy="office-communication-content">
    <div #messageContainer class="office-communication-message-content" data-cy="office-communication-message-container">
      <ng-container *ngIf="selectedConversation && selectedConversation.dataTDOChats">
        <div *ngFor="let chat of selectedConversation.dataTDOChats" class="message-body" data-cy="office-communication-message-{{chat.TDOChatID}}">
          <div *ngIf="isSelfUser(chat.SenderUserID)" class="message-timestamp" style="margin-left: auto; text-align: right" data-cy="office-communication-self-timestamp">
            <div data-cy="office-communication-timestamp-text">{{getTime(chat.xauditModifiedOn)}}</div>
          </div>
          <div [class]="{'self-message': isSelfUser(chat.SenderUserID), 'other-message': !isSelfUser(chat.SenderUserID)}" data-cy="office-communication-message-text">{{chat.Message}}</div>
          <div *ngIf="!isSelfUser(chat.SenderUserID)" class="message-timestamp" data-cy="office-communication-other-timestamp">{{getTime(chat.xauditModifiedOn)}}</div>
        </div>
      </ng-container>
    </div>
    <div class="office-communication-input" data-cy="office-communication-input-container">
      <input style="flex: 1;" [(ngModel)]="inputMessage" data-cy="office-communication-input-field" />
      <button (click)="onSendPressed()" [disabled]="inputMessage.length === 0" class="tdo-button tdo-save" data-cy="office-communication-send-btn">Send</button>
    </div>
  </div>
</div>
